import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-dl-checkbox',
  templateUrl: './dl-checkbox.component.html',
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DlCheckboxComponent),
      multi: true
    }
  ]
})
export class DlCheckboxComponent implements ControlValueAccessor {
  @Input() checkboxId: string;
  @Input() label: string;
  @Input() description: string;
  @Input() required = false;
  @Input() invalid = false;

  checked = false;

  private onChange: (v: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: boolean): void {
    this.checked = !!value;
  }

  registerOnChange(fn: (v: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  disabled = false;

  onCheckedChange(value: boolean): void {
    this.checked = value;
    this.onChange(value);
    this.onTouched();
  }
}
